import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanLinkedReleaseSchema } from './shapes';

export const linkPlanRelease = defineEndpoint({
  method: 'POST',
  path: '/v1/release-plans/:planId/releases',
  params: z.object({ planId: z.string().uuid() }),
  query: z.object({}),
  body: z.object({ releaseId: z.string().uuid() }),
  response: z.object({ data: z.array(PlanLinkedReleaseSchema) }),
  successStatus: 201,
});
